import labelizer from '../helpers/labelizer'
import textValues from '../text-values'

export default {
    data: () => textValues,
    methods: labelizer,
}
